import { render, staticRenderFns } from "./QuestionItem.vue?vue&type=template&id=a18a69c4&scoped=true"
import script from "./QuestionItem.vue?vue&type=script&lang=js"
export * from "./QuestionItem.vue?vue&type=script&lang=js"
import style0 from "./QuestionItem.vue?vue&type=style&index=0&id=a18a69c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a18a69c4",
  null
  
)

export default component.exports